import { httpService } from 'core-utilities';
import { dataStores } from 'core-roblox-utilities';
import { authenticatedUser } from 'header-scripts';
import { AxiosResponse } from 'axios';
import bedev1Constants from '../constants/bedev1Constants';
import {
  TGetOmniRecommendationsMetadataResponse,
  TGetOmniRecommendationsResponse,
  TOmniRecommendation,
  TGetFriendsResponse,
  TGetGameDetails,
  TPageType,
  TMetaData,
  TGameData
} from '../types/bedev1Types';

const { url, defaultCacheCriteria } = bedev1Constants;
const { gamesDataStore, userDataStoreV2 } = dataStores;

export const getOmniRecommendations = async (
  pagetype: TPageType,
  sessionId?: string
): Promise<TGetOmniRecommendationsResponse> => {
  const { data } = await httpService.get(
    bedev1Constants.url.getOmniRecommendations(pagetype, sessionId)
  );
  return data as TGetOmniRecommendationsResponse;
};

export const getOmniRecommendationsMetadata = async (
  recommendationList: TOmniRecommendation[]
): Promise<TGetOmniRecommendationsMetadataResponse> => {
  const { data } = await httpService.post(bedev1Constants.url.getOmniRecommendationsMetadata, {
    Contents: recommendationList
  });
  return data as TGetOmniRecommendationsMetadataResponse;
};

export const getGameList = async (
  keyword: string,
  start: number,
  max: number
): Promise<{ metaData: TMetaData; games: TGameData[] }> => {
  const {
    data: { games = [], ...metaData }
  } = await httpService.get(url.getGameList, {
    keyword,
    startRows: start,
    maxRows: max,
    isKeywordSuggestionEnabled: true
  });
  return ({ games, metaData } as unknown) as { games: TGameData[]; metaData: TMetaData };
};

export const getFriendsPresence = (): Promise<{ userData?: TGetFriendsResponse[] }> => {
  return userDataStoreV2.getFriends(
    {
      userId: authenticatedUser?.id,
      isGuest: false
    },
    defaultCacheCriteria
  ) as Promise<{ userData?: TGetFriendsResponse[] }>;
};

export const getGameDetails = async (placeId: number): Promise<TGetGameDetails> => {
  const { data = [] } = ((await gamesDataStore.getPlaceDetails([
    placeId
  ])) as unknown) as AxiosResponse<TGetGameDetails[]>;
  return data[0];
};

export default {
  getOmniRecommendations,
  getOmniRecommendationsMetadata,
  getGameList,
  getFriendsPresence,
  getGameDetails
};
